import {MouseEvent, useState} from "react"
import {Modal, useMediaQuery, Paper, IconButton} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import {styled} from "@mui/material/styles"

const StyledPaper = styled(({mobile, ...props}) => <Paper {...props} />)(({theme, mobile}) => ({
	position: "relative",
	width: mobile ? "90%" : "400px",
	maxHeight: "95%",
	backgroundColor: theme.palette.background.paper,
	boxShadow: theme.shadows[5],
	padding: theme.spacing(2, 4, 2),
	outline: "none",
	overflow: "auto",
	top: "50%",
	left: theme.direction === "rtl" ? "auto" : "50%",
	right: theme.direction === "rtl" ? "50%" : "auto",
	transform: theme.direction === "rtl" ? "translate(50%, -50%)" : "translate(-50%, -50%)",
	borderRadius: "24px",
	paddingBottom: "20px",
}))

const useModal = ({onClose}: {onClose?: (event: MouseEvent<HTMLDivElement>, reason: string) => void} = {}) => {
	const [isOpen, setIsOpen] = useState(false)
	const mobile = useMediaQuery("(max-width:599px)")

	const handleClose = (event: MouseEvent<HTMLDivElement>, reason: string) => {
		onClose?.(event, reason)
		setIsOpen(false)
	}

	return {
		Open: () => {
			setIsOpen(true)
		},
		Close: handleClose,
		Component: ({children, disableBackdropClick = false, disableEscapeKeyDown = false}) => (
			<Modal
				open={isOpen}
				onClose={handleClose}
				disableBackdropClick={disableBackdropClick}
				disableEscapeKeyDown={disableEscapeKeyDown}
				aria-labelledby="modal-title"
				aria-describedby="modal-description"
			>
				<StyledPaper mobile={mobile}>{children}</StyledPaper>
			</Modal>
		),

		CloseIconButton: ({disabled = false}) => (
			<IconButton aria-label="close" onClick={handleClose} disabled={disabled}>
				<CloseIcon htmlColor="rgba(50,50,50,0.45)" />
			</IconButton>
		),
	}
}

export {useModal}
